const initialState = {
    isSkipingCallback: false,
}

export default initialState;
